import { render, staticRenderFns } from "./FormResourceEdit.vue?vue&type=template&id=49e5e314&"
import script from "./FormResourceEdit.vue?vue&type=script&lang=js&"
export * from "./FormResourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports